// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"CoachPage_toolbar__282hV","buttons":"CoachPage_buttons__2t3SA","save":"CoachPage_save__Y_TeI","delete":"CoachPage_delete__h4pIM","back":"CoachPage_back__34VhN"};